import { useEffect, useMemo, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useShallowEqualSelector } from '@/hooks';
import { setCurrency } from '@/store/profile';
import { fetchCurrencies } from '@/store/profile/thunks';

export function useCurrencySelector({ fetchOnOpen = false, prices = [] }) {
	const dispatch = useDispatch();

	const { currency, currencies, fetchingCurrencies, currenciesReady } =
		useShallowEqualSelector(state => ({
			currency: state.profile.currency,
			currencies: state.profile.currencies || [],
			fetchingCurrencies: state.profile.fetchCurrencies.loading,
			currenciesReady: state.profile.fetchCurrencies.success
		}));
	const [open, setOpen] = useState(false);

	function onChange(value) {
		dispatch(setCurrency(value));
	}

	useEffect(() => {
		if (!currencies.length || !currency) {
			return;
		}
		if (!currencies.includes(currency)) {
			onChange(null);
		}
	}, [currencies.length]);

	useEffect(() => {
		if (currenciesReady || (fetchOnOpen && !open)) {
			return;
		}

		dispatch(fetchCurrencies());
	}, [open, currenciesReady]);

	const planCurrency = useMemo(() => {
		if (currency) {
			return null;
		}
		return prices.find(price => price.active)?.currency.toLowerCase();
	}, [currency, prices]);

	return {
		currencies,
		currency,
		fetchingCurrencies,
		open,
		setOpen,
		onChange,
		currenciesReady,
		planCurrency
	};
}
